import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../../services/config';
import { WorkingHoursModel, WorkingHoursResponseModel } from './models';
import { WorkingHoursEndpoint } from './constants';

@Injectable({
  providedIn: 'root',
})
export class WorkingHoursService {
  constructor(private http: WrapperHttpService) {}

  getWorkingHoursList(compartmentId: number, dockId?: number): Observable<WorkingHoursResponseModel> {
    let url = `${API_URL}${WorkingHoursEndpoint.WorkingHours}${WorkingHoursEndpoint.Compartment}/${compartmentId}`;
    if (dockId) {
      url += `${WorkingHoursEndpoint.Dock}/${dockId}`;
    }
    return this.http.withLoading().get<WorkingHoursResponseModel>(url);
  }

  getWorkingHoursItem(workingHoursId: number, compartmentId: number, dockId?: number): Observable<WorkingHoursModel> {
    let baseUrl = `${API_URL}${WorkingHoursEndpoint.WorkingHours}${WorkingHoursEndpoint.Compartment}/${compartmentId}`;
    if (dockId) {
      baseUrl += `${WorkingHoursEndpoint.Dock}/${dockId}`;
    }

    return this.http.withLoading().get<WorkingHoursModel>(`${baseUrl}/${workingHoursId}`);
  }

  updateWorkingHours(body: WorkingHoursModel, compartmentId: number, dockId: number): Observable<WorkingHoursModel> {
    let url = `${API_URL}${WorkingHoursEndpoint.WorkingHours}${WorkingHoursEndpoint.Compartment}/${compartmentId}`;
    if (dockId) {
      url += `${WorkingHoursEndpoint.Dock}/${dockId}`;
    }
    return this.http.withLoading().post<WorkingHoursModel>(url, body);
  }

  deleteWorkingHours(workingHoursIds: number[], compartmentId: number, dockId: number): Observable<void> {
    let url = `${API_URL}${WorkingHoursEndpoint.WorkingHours}${WorkingHoursEndpoint.Compartment}/${compartmentId}`;
    if (dockId) {
      url += `${WorkingHoursEndpoint.Dock}/${dockId}`;
    }

    return this.http.withLoading().delete<void>(url, { body: workingHoursIds });
  }
}
